var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadv2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_7449)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_59_7449)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_59_7449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00125 15.5576C4.01883 15.5552 3.07167 15.1912 2.34039 14.5352C1.60911 13.8792 1.1449 12.9769 1.03626 12.0005C0.927617 11.0242 1.18217 10.0419 1.75135 9.2412C2.32054 8.44047 3.16455 7.87726 4.12241 7.65898C3.84398 6.36243 4.092 5.00839 4.81192 3.89471C5.53184 2.78104 6.66467 1.99897 7.96121 1.72054C9.25776 1.44211 10.6118 1.69014 11.7255 2.41005C12.8392 3.12997 13.6212 4.2628 13.8997 5.55935H13.9996C15.2394 5.5581 16.4353 6.01754 17.3554 6.84849C18.2754 7.67943 18.8539 8.82259 18.9785 10.056C19.103 11.2895 18.7649 12.5252 18.0296 13.5234C17.2943 14.5215 16.2144 15.2109 14.9995 15.4576M7.00089 18.557L10.0004 21.5565M10.0004 21.5565L12.9998 18.557M10.0004 21.5565V9.55863",
    stroke: "#111827",
    strokeWidth: 1.99964,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_7449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22.41,
    fill: "white",
    transform: "translate(0 0.559998)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_59_7449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22.41,
    fill: "white",
    transform: "translate(0 0.559998)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_59_7449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9964,
    height: 22.41,
    fill: "white",
    transform: "translate(0.00195312 0.559998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadv2);
export default __webpack_public_path__ + "static/media/downloadv2.6cc8445c9d1a6c02774d3ac1a44394ba.svg";
export { ForwardRef as ReactComponent };